import { IRouteType } from '../../types'
import pnl from '../common/pnl'
import pnlConfig from '../common/pnlConfig'
import pnlRankings from '../common/pnlRankings'

export const routes: IRouteType[] = [
  {
    title: 'P&L',
    children: [
      {
        title: 'Expo AI P&L',
        link: '/:brand/pnl',
        default: true,
      },
      {
        title: 'Expo AI P&L Rankings',
        link: '/:brand/pnl-rankings',
      },
      {
        title: 'Config',
        link: '/:brand/pnl-config',
        hideFromNavMenu: true,
      },
    ],
  },
]

export default [
  pnl({ brand: 'gvcs' }),
  pnlConfig('gvcs'),
  pnlRankings({ brand: 'gvcs' }),
]
